var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-content',{attrs:{"scroll-x":"true"}},[(_vm.enrollmentType)?_c('EnrollForm',_vm._b({},'EnrollForm',{
      restMethod: _vm.restMethod,
      isApproval: _vm.isApproval,
      url: _vm.url,
      authToken: _vm.authToken
    },false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }